module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.description),
      expression: "inventory.description"
    }],
    staticClass: "form-control",
    attrs: {
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "type": "text",
      "name": "description",
      "id": "inventory_description",
      "placeholder": "Search descriptions...",
      "disabled": _vm.title === 'Edit Inventory'
    },
    domProps: {
      "value": (_vm.inventory.description)
    },
    on: {
      "keyup": function($event) {
        return _vm.itemLiveSearch(_vm.inventory.description)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemRows && _vm.itemRows.length),
      expression: "itemRows && itemRows.length"
    }],
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-height": "250px"
    },
    attrs: {
      "id": "itemCustomLiveSearch"
    }
  }, [_vm._l((_vm.itemRows), function(item, index) {
    return [_c('div', {
      key: index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.itemSelected(item)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.description) + "\n                ")])]
  })], 2), _vm._v(" "), (_vm.loading) ? _c('span', {
    staticClass: "text-muted"
  }, [_c('ThreeDots', {
    attrs: {
      "size": "18px"
    }
  }), _vm._v(" Searching...")], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_internalId"
    }
  }, [_vm._v("Internal ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.internalId),
      expression: "inventory.internalId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "internalId",
      "id": "inventory_internalId",
      "placeholder": "",
      "disabled": true
    },
    domProps: {
      "value": (_vm.inventory.internalId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "internalId", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_htsCode"
    }
  }, [_vm._v("HTS Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.htsCode),
      expression: "inventory.htsCode"
    }],
    staticClass: "form-control",
    attrs: {
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "type": "text",
      "name": "htsCode",
      "id": "inventory_htsCode",
      "placeholder": "Search HTS codes...",
      "disabled": _vm.title === 'Edit Inventory'
    },
    domProps: {
      "value": (_vm.inventory.htsCode)
    },
    on: {
      "keyup": function($event) {
        return _vm.htsLiveSearch(_vm.inventory.htsCode)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "htsCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.htsRows && _vm.htsRows.length),
      expression: "htsRows && htsRows.length"
    }],
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-height": "250px"
    },
    attrs: {
      "id": "htsCustomLiveSearch"
    }
  }, [_vm._l((_vm.htsRows), function(row, index) {
    return [_c('div', {
      key: index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.htsSelected(row)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(row.htsCode + " - " + row.rollupDescription) + "\n                ")])]
  })], 2), _vm._v(" "), (_vm.htsLoading) ? _c('span', {
    staticClass: "text-muted"
  }, [_c('ThreeDots', {
    attrs: {
      "size": "18px"
    }
  }), _vm._v(" Searching...")], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_rollupDescription"
    }
  }, [_vm._v("Rollup Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.rollupDescription),
      expression: "inventory.rollupDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rollupDescription",
      "id": "inventory_rollupDescription",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.inventory.rollupDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "rollupDescription", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_productCode"
    }
  }, [_vm._v("Product Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.productCode),
      expression: "inventory.productCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "productCode",
      "id": "inventory_productCode",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.inventory.productCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "productCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_fda"
    }
  }, [_vm._v("FDA")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.fda),
      expression: "inventory.fda"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "fda",
      "id": "inventory_fda",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.inventory.fda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "fda", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_unitsPerCase"
    }
  }, [_vm._v("Units Per Case")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.unitsPerCase),
      expression: "inventory.unitsPerCase"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "unitsPerCase",
      "id": "inventory_unitsPerCase",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.inventory.unitsPerCase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "unitsPerCase", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_pricePerUnit"
    }
  }, [_vm._v("Price Per Unit "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.netSuitePriceWarn))])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.pricePerUnit),
      expression: "inventory.pricePerUnit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "pricePerUnit",
      "id": "inventory_pricePerUnit",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.inventory.pricePerUnit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "pricePerUnit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_origin"
    }
  }, [_vm._v("Origin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.origin),
      expression: "inventory.origin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "origin",
      "id": "inventory_origin",
      "placeholder": "Country of origin",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.inventory.origin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "origin", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "api_integration"
    }
  }, [_vm._v("API Integration")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.apiIntegration),
      expression: "inventory.apiIntegration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "apiIntegration",
      "id": "api_integration",
      "placeholder": "API integration key",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.inventory.apiIntegration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory, "apiIntegration", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_unpacked"
    }
  }, [_vm._v("Unpacked")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.unpacked),
      expression: "inventory.unpacked"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "unpacked",
      "id": "inventory_unpacked"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inventory, "unpacked", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_isContainer"
    }
  }, [_vm._v("Is a container")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.isContainer),
      expression: "inventory.isContainer"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "isContainer",
      "id": "inventory_isContainer"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inventory, "isContainer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inventory_shippingType"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.type),
      expression: "inventory.type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type",
      "id": "inventory_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inventory, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("None")]), _vm._v(" "), _c('option', [_vm._v("Pallet")]), _vm._v(" "), _c('option', [_vm._v("Skid")]), _vm._v(" "), _c('option', [_vm._v("Slipsheet")]), _vm._v(" "), _c('option', [_vm._v("Tote")]), _vm._v(" "), _c('option', [_vm._v("Pallet Box")]), _vm._v(" "), _c('option', [_vm._v("Skid Box")]), _vm._v(" "), _c('option', [_vm._v("Bin")]), _vm._v(" "), _c('option', [_vm._v("Basket")]), _vm._v(" "), _c('option', [_vm._v("Rack")]), _vm._v(" "), _c('option', [_vm._v("Carton")]), _vm._v(" "), _c('option', [_vm._v("Bag")]), _vm._v(" "), _c('option', [_vm._v("Drum")]), _vm._v(" "), _c('option', [_vm._v("Crate")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "length"
    }
  }, [_vm._v("Length (inches)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.dimensions.length),
      expression: "inventory.dimensions.length"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "length",
      "id": "length",
      "placeholder": "Length in inches"
    },
    domProps: {
      "value": (_vm.inventory.dimensions.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory.dimensions, "length", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "width"
    }
  }, [_vm._v("Width (inches)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.dimensions.width),
      expression: "inventory.dimensions.width"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "width",
      "id": "width",
      "placeholder": "Width in inches"
    },
    domProps: {
      "value": (_vm.inventory.dimensions.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory.dimensions, "width", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "height"
    }
  }, [_vm._v("Height (inches)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.dimensions.height),
      expression: "inventory.dimensions.height"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "height",
      "id": "height",
      "placeholder": "Height in inches"
    },
    domProps: {
      "value": (_vm.inventory.dimensions.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory.dimensions, "height", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "weight"
    }
  }, [_vm._v("Weight (lbs)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventory.dimensions.weight),
      expression: "inventory.dimensions.weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "weight",
      "id": "weight",
      "placeholder": "Weight in lbs"
    },
    domProps: {
      "value": (_vm.inventory.dimensions.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inventory.dimensions, "weight", $event.target.value)
      }
    }
  })])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Dimensions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c242988"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/InventoryForm.vue
// module id = 730
// module chunks = 0